import type { IconNode } from '../types';

/**
 * @name letter-z
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA0aDExLjVhLjUuNSAwIDAxLjM4Ny44MTdMNi4xMTQgMTkuMTgzYS41LjUgMCAwMC4zODcuODE3SDE4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/letter-z
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterZ: IconNode = [
  ['path', { d: 'M6 4h11.5a.5.5 0 01.387.817L6.114 19.183a.5.5 0 00.387.817H18' }],
];

export default LetterZ;
